import{useContext as r}from"react";import o from"./renderer-context.js";export default function useFormApi(){return r(o).formOptions}
//# sourceMappingURL=use-form-api.js.map
